import {
  EntityMetadata,
  EntityModel,
  FieldDefinition,
  readEntityModelIncludeExternal,
  ViewModel,
} from '@msdk/definitions'

export function getDynamicViewFieldDefinition(
  viewModel: ViewModel,
  baseMetadata: EntityMetadata | undefined,
  column: string,
): FieldDefinition {
  const fieldName = viewModel.getFieldNameForColumn(column)
  const entityName = viewModel.getEntityNameForColumn(column)
  const inline = viewModel.columns.find((c) => c.fieldName === column)?.inlineDefinition

  if (inline) return inline

  const model = readEntityModelIncludeExternal(entityName, baseMetadata?.msProvider as string) as EntityModel
  return model.getFieldDefinition(fieldName)
}
